<template>
    <v-container class="d-flex align-center justify-start pa-0 px-2" data-testid="profile-stack">
        <div data-testid="profile-stack__header">
        <h6 class="text-capitalize font-weight-regular pa-0 ma-0" data-testid="profile-stack__title">{{heading}}</h6>

        <v-menu
            v-if="!readonly"
            v-model="menuOpen"
            :close-on-content-click="false"
            offset-y
            color="white"
            class="pa-0 ma-0"
            style="background-color: white;"
            data-testid="profile-stack__edit-menu"
        >
        <template v-slot:activator="{ on, attrs }">
            <span
            v-bind="attrs"
            v-on="on"
            class="pa-0 blue--text"
            @click="openUserlist = 1"
            data-testid="profile-stack__edit-btn"
            >Edit
            </span>
        </template>

        <div v-if="openUserlist" data-testid="profile-stack__edit-list">
            <v-list-title class="ma-0 all-width" >
                <div
                  class="d-flex tableHeaderBg align-center pa-2 pb-3 pt-3 pb-1"
                  data-testid="profile-stack__edit-list-header"
                >
                  <v-btn icon @click="openUserlist = 0" data-testid="profile-stack__edit-list-back-btn">
                    <v-icon data-testid="profile-stack__edit-list-back-icon">mdi-keyboard-backspace</v-icon>
                  </v-btn>
                  <p class="ma-0 font-weight-bold" data-testid="profile-stack__edit-list-title">Choose {{ heading }}</p>
                  <v-icon color="primary" data-testid="profile-stack__edit-list-info-icon"
                    >mdi-information-outline</v-icon
                  >
                </div>
            </v-list-title>
            <v-list class="overflow-hidden radius-small pa-0 pt-2 mb-0" style="min-width: 18vh;" data-testid="profile-stack__edit-list-menu">
                <v-divider data-testid="profile-stack__edit-list-divider-top"></v-divider>
                <div class="overflow-scroll px-2 userMenu" data-testid="profile-stack__edit-list-user-menu">
                    <lb-string
                    label=""
                    placeholder="search"
                    append-icon="mdi-magnify"
                    class="mt-1 all-width"
                    hidedetails
                    v-model="searchUser"
                    data-testid="profile-stack__edit-list-search"
                    />
                <v-list-item
                    v-for="(item, index) in labelAttachedUserNames"
                    :key="index"
                    class="pa-0"
                    style="background-color: white;"
                    data-testid="profile-stack__edit-list-item"
                >
                    <v-list-item-content class="pa-0 ma-0" data-testid="profile-stack__edit-list-item-content">
                    <v-checkbox
                        :ripple="false"
                        class="pa-0 ma-0"
                        @change="checkedData(item)"
                        hide-details
                        color="caccounting"
                        :input-value="ifUserSelected(item)"
                        :label="item.name"
                        data-testid="profile-stack__edit-list-checkbox"
                    >
                    <template v-slot:label>
                        <span :class="item.inactive ? 'red--text font-weight-bold' : ''" data-testid="profile-stack__edit-list-checkbox-label">
                        {{ item.name ? item.name : '' }}
                        </span>
                    </template>
                   </v-checkbox>
                    </v-list-item-content>
                </v-list-item>
                </div>
                <v-divider data-testid="profile-stack__edit-list-divider-bottom"></v-divider>
                <div class="d-flex justify-space-between" data-testid="profile-stack__edit-list-actions">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" class="ma-1" @click="updateuser()" data-testid="profile-stack__edit-list-update-btn"><span data-testid="profile-stack__edit-list-update-label">Update</span></v-btn>
                </div>
            </v-list>
        </div>
        </v-menu>

        </div>
        <v-spacer></v-spacer>
        <div class="d-flex all-width justify-start ml-8 pt-1" data-testid="profile-stack__avatars-row">
                <div class="d-flex" data-testid="profile-stack__avatars-group">
                    <div
                      v-for="(item, index) in items.slice(0, 3)"
                      :key="index"
                       class="avatars-group__item "
                       data-testid="profile-stack__avatar-item"
                    >
                      <v-tooltip top content-class="tooltip-top" data-testid="profile-stack__avatar-tooltip">
                        <template v-slot:activator="{ on }">
                          <v-avatar
                            v-on="on"
                            size="27"
                            color="caccounting"
                            class="white--text border-on d-flex pa-0 ma-0 v-avatar"
                            data-testid="profile-stack__avatar"
                        >
                            <span data-testid="profile-stack__avatar-initial">{{ getusernamefrommainlist(item)[0] }}</span>
                        </v-avatar>
                        </template>
                    <span data-testid="profile-stack__avatar-name"> <span>{{ getusernamefrommainlist(item) }}</span></span>
                      </v-tooltip>
                    </div>
                  </div>

            <v-tooltip v-if="items.length > 3 && items.length < 8"  top content-class="tooltip-top" data-testid="profile-stack__avatar-tooltip-more">
                <template v-slot:activator="{ on, attrs }">
                    <v-avatar 
                        v-bind="attrs" 
                        v-on="on"
                        size="25"
                        color="lightpurple"
                        style="margin-left:-6px !important"
                        class="caccounting--text d-flex align-center justify-center pa-0 ma-0"
                        data-testid="profile-stack__avatar-more"
                    >
                    <v-icon color="caccounting" data-testid="profile-stack__avatar-more-icon">mdi-plus</v-icon>
                    </v-avatar>
                </template>
                <div class="" v-for="(name,index) in items.slice(3)" :key=index data-testid="profile-stack__avatar-more-list">
                    <span data-testid="profile-stack__avatar-more-name">{{getusernamefrommainlist(name)}}</span>
                </div>
            </v-tooltip>

            <v-menu
                v-else-if=" items.length >= 8" 
                v-model="dropdown"
                :close-on-content-click="false"
                offset-y
                color="white"
                class="pa-0 ma-0"
                style="background-color:white"
                data-testid="profile-stack__avatar-menu"
            >
            <template v-slot:activator="{ on, attrs }">
            <v-avatar
                size="25"
                color="lightpurple"
                class="caccounting--text d-flex align-center justify-center pa-0 ma-0"
                v-bind="attrs"
                v-on="on"
                style="margin-left:-6px !important"
                data-testid="profile-stack__avatar-menu-btn"
            >
                <v-icon color="caccounting" data-testid="profile-stack__avatar-menu-icon">mdi-plus</v-icon>
            </v-avatar>
            </template>
            <v-list class="overflow-hidden radius-small pa-0 pt-2 mb-0 " style="min-width:18vh" data-testid="profile-stack__avatar-menu-list">
            <div class="font-weight-bold text-subtitle px-3 pb-1 d-flex justify-space-between" data-testid="profile-stack__avatar-menu-list-header">
                <p class="pa-0 ma-0 " data-testid="profile-stack__avatar-menu-list-title">{{heading}}</p>
                <v-icon data-testid="profile-stack__avatar-menu-list-info-icon">mdi-information-outline</v-icon>
            </div>
            <v-divider data-testid="profile-stack__avatar-menu-list-divider"></v-divider>
            <div class="overflow-scroll px-2 userMenu" data-testid="profile-stack__avatar-menu-list-user-menu">
                <v-list-item
                    v-for="(item, index) in items.slice(3)"
                    :key="index"
                    style="background-color:white"
                    class="pa-0"
                    data-testid="profile-stack__avatar-menu-list-item"
                >
                    <v-list-item-content  class="pa-0 ma-0" data-testid="profile-stack__avatar-menu-list-item-content">
                        <span data-testid="profile-stack__avatar-menu-list-item-name"> {{ getusernamefrommainlist(item) }}</span>
                    </v-list-item-content>
                </v-list-item>
            </div>
            </v-list>
            </v-menu>
        </div>
    </v-container>
</template>
<script>
import { attachInactiveLabel } from '../../modules/financialclose/utils/tasklistUtils';

export default {
    name: 'ProfileStack',
    data:  function() {
        return {
                dropdown :"",
                newdataa:[],
                presence: false,
                stackedLimit: 6,
                menuOpen: this.value,
                openUserlist: 1,
                searchUser: "", 
            }
    },
    props: {
        items: {
            type: Array,
            default: function () {
                return [];
            },
        },
        heading:{
            type:String,
            default:"",
        },
        allUser: {
            type: Array,
            default: function () {
                return [];
            },
        },
        value: {
            type: [Boolean, Array], // Should match your usage
            default: function () {
                return false;
            },
        },
        updateFunction:{
            type: Function,
        },
        activeUsers:{
            type: Array,
            default: function () {
                return [];
            },
        },
        readonly: {
            type: Boolean,
            default: false,
        }
        
    },
    computed: {
        avatarsSorted() {
            return [...this.items].sort((a, b) => a.alt.localeCompare(b.alt));
        },
        avatarsStackedLimited() {
            return this.avatarsSorted.slice(0, this.stackedLimit);
        },
        activeUserIds(){
            return this.activeUsers.map(user => typeof user === 'string' ? user : (user?.id || user?._id));
        },
        labelAttachedUserNames() {
            const searchTerm = this.searchUser?.toLowerCase() ?? "";
            const selectedIds = this.items.map(item => typeof item === 'object' ? item._id : item);
            // Check if any selected user is inactive
            const hasInactive = selectedIds.some(userId => !this.activeUserIds.includes(userId));
            // If any selected user is inactive, show inactive users with inactive label, else show only active users
            let userList = hasInactive
            ? attachInactiveLabel(this.allUser, this.activeUserIds)
            : this.allUser?.filter(user => this.activeUserIds.includes(user?._id));
            return userList?.filter(user => user?.name.toLowerCase().includes(searchTerm)) || [];
        }
    },
    methods: {
        updateuser(){ 
           this.menuOpen = false;
           if (this.updateFunction) this.updateFunction();
        },
        checkedData(item){
            if(this.items.includes(item._id)){
                let elementIndex = this.items.indexOf(item._id)
                this.items.splice(elementIndex, 1)
            }
            else
            {
                this.items.push(item._id)
            }
        },
        userNames(){
            let usernameslist = this.items.map((item)=>{
                return item._id
            })            
            return usernameslist.splice(3,usernameslist.length)
        },
        ifUserSelected(value) {
            const selectedusers = this.labelAttachedUserNames.filter(user => this.items.includes(user._id));
            return selectedusers.includes(value);
        },
        getusername(id){
            
            const name = (this.items || []).find(
                (loc) => loc._id === id
            );
            return name ? name.name : "Unknown";
        },
        getusernamefrommainlist(id) {
            if (typeof id === 'object' && id !== null) {
                id = id._id;  
            }
            const name = (this.allUser || []).find(
                (loc) => loc._id === id
            );
            return name ? name.name : "Unknown";
        }

    },
    watch: {
        value(val) {
            this.menuOpen = val;
        },
        menuOpen(val) {
            this.$emit('input', val); // or 'update:value' for v-model:value
        }
    },
}

</script>

<style scoped>
.userMenu{
    max-height: 23vh !important;
    background-color: white;
    overflow: scroll;
}
  
  .v-tooltip .v-tooltip__content {
    white-space: nowrap;
  }
</style> 


